import React, { useState } from 'react';
import { SECTION_TYPE_OPTIONS, suggestSectionCode } from '../adapters';

const AddSectionDialog = ({ open, onClose, onSubmit, existingCodes = [] }) => {
  const [form, setForm] = useState({
    sectionName: '',
    sectionType: 'CUSTOM',
    visible: true,
    printVisible: true,
    collapsible: false,
  });
  if (!open) return null;

  const submit = () => {
    if (!form.sectionName.trim()) return;
    let code = suggestSectionCode(form.sectionName);
    const set = new Set(existingCodes.map((c) => String(c).toUpperCase()));
    if (set.has(code)) {
      let i = 2;
      while (set.has(`${code}_${i}`)) i += 1;
      code = `${code}_${i}`;
    }
    onSubmit({
      sectionCode: code,
      sectionName: form.sectionName.trim(),
      sectionType: form.sectionType,
      visible: form.visible,
      printVisible: form.printVisible,
      collapsible: form.collapsible,
      active: true,
      sequence: (existingCodes.length + 1) * 10,
    });
    setForm({ sectionName: '', sectionType: 'CUSTOM', visible: true, printVisible: true, collapsible: false });
  };

  return (
    <div className="ra-tpl-modal-overlay" onClick={onClose}>
      <div className="ra-tpl-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Add Section</h3>
        <div className="form-group">
          <label>Section Name</label>
          <input value={form.sectionName} onChange={(e) => setForm((p) => ({ ...p, sectionName: e.target.value }))} placeholder="Recoveries" />
        </div>
        <div className="form-group">
          <label>Section Type</label>
          <select value={form.sectionType} onChange={(e) => setForm((p) => ({ ...p, sectionType: e.target.value }))}>
            {SECTION_TYPE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        <div className="ra-tpl-check-grid">
          <label><input type="checkbox" checked={form.visible} onChange={(e) => setForm((p) => ({ ...p, visible: e.target.checked }))} /> Show in Form</label>
          <label><input type="checkbox" checked={form.printVisible} onChange={(e) => setForm((p) => ({ ...p, printVisible: e.target.checked }))} /> Show in Print</label>
          <label><input type="checkbox" checked={form.collapsible} onChange={(e) => setForm((p) => ({ ...p, collapsible: e.target.checked }))} /> Collapsible</label>
        </div>
        <div className="ra-tpl-modal-actions">
          <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
          <button type="button" className="btn-primary" onClick={submit}>Add Section</button>
        </div>
      </div>
    </div>
  );
};

export default AddSectionDialog;
